import React, { useEffect, useMemo, useState } from 'react';
import styles from './Sales.module.scss';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { Dispatch } from 'redux';
import classnames from 'classnames';
import { get, isEmpty } from 'lodash';
import parse from 'html-react-parser';

//carousel
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
//assets
import SVG from 'react-inlinesvg';
import tipIcon from '../../assets/icons/sales/web-tip.png';
import premiumIcon from '../../assets/icons/sales/premium.svg';
import dropdown from '../../assets/dropdown.svg';
import closeIcon from '../../assets/icons/close.svg';
//components
import { SalesBarChart } from './Charts/SalesBarChart';

//data
import { DashboardState } from '../../store/dashboard/reducer';
import { LoginState } from '../../store/login/reducer';
import { dashboardActions } from '../../store/dashboard/actions';
//functions
import {
  periodFilterValues,
  responsiveConfig,
  formatNumber,
} from './Utils/dashboardUtils';
//Tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';
import { useAnalyticsHandlers } from '../../analytics/__providers__/AnalyticsHandlersProvider';
import { getCurrencyValue } from '../PaymentGateway/utils/functions';
import { SalesTableConnected } from './Charts/Earnings/SalesTable';
import {
  FeeTier,
  FeeTiers,
  Sale,
  SalesSummary,
} from '../../sagas/dashboard/types';
import { OutsideAlerter } from '../TipPublish/shared/OutsideAlerter/OutsideAlerter';
import { MONTH_NAMES } from '../TipPublish/utils/buildCustomDate';
import { toProperCase } from '../TipPublish/utils/toProperCase';
import { FeeInfoModal } from './FeeInfoModal';

export interface StateProps {
  loading: boolean;
  dashboardState: DashboardState;
  loginState: LoginState;
}
export interface DispatchProps {
  getSales: (queryparams: any) => any;
}
type SalesProps = StateProps & DispatchProps;

export const Sales: React.FC<SalesProps> = (props) => {
  const { t } = useTranslation();
  const analytics = useAnalyticsHandlers();
  const cx = classnames.bind(styles);
  const now = new Date();
  const [isOpenPeriodFilter, setIsOpenPeriodFilter] = useState(false);
  const [isOpenTypeFilter, setIsOpenTypeFilter] = useState(false);
  const [isFeeTierModalOpen, setIsFeeTierModalOpen] = useState<boolean>(false);
  const [isFeeInfoModalOpen, setIsFeeInfoModalOpen] = useState<boolean>(false);
  const [periodFilter, setPeriodFilter] = useState({
    key: 'HISTORIC',
    label: tr(t, 'HISTORIC'),
  });
  const [typeFilter, setTypeFilter] = useState({
    key: 'ALL',
    label: 'total',
  });
  const [page, setPage] = useState(1);
  const typeFilters = [
    { key: 'TIPS', label: 'tips' },
    { key: 'PREMIUMS', label: 'premium' },
    { key: 'ALL', label: 'total' },
  ];
  const { getSales, dashboardState, loginState } = props;
  const userId = get(loginState, ['user', 'user', 'id']);
  const userCurrency = get(loginState, ['user', 'user', 'currency']);
  const tipsterFeeType = get(loginState, ['user', 'user', 'tipster_fee_type']);
  const userName = get(loginState, ['user', 'user', 'username']);
  const handleTypeFilter = (type: { key: string; label: string }) => {
    if (!dashboardState.isLoading) {
      setTypeFilter(type);
      setPage(1);
      getSales({ period_filter: periodFilter.key, type_filter: type.key });
      setIsOpenTypeFilter(false);
    }
  };
  useEffect(() => {
    getSales({
      period_filter: periodFilter.key,
      type_filter: typeFilter.key,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    analytics!.client.BIEvent.log('EARNINGS_PAGE_VISITED', {
      values: [
        {
          additional_info: `${typeFilter.key}/${periodFilter.key}`,
        },
      ],
      userID: userId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodFilter, typeFilter]);

  const salesSummary: SalesSummary = get(dashboardState, ['salesSummary']);

  if (
    salesSummary &&
    salesSummary.currentMonthGrossRevenue &&
    salesSummary.currentMonthGrossRevenue.decimals === 0
  ) {
    salesSummary.currentMonthGrossRevenue.currency = userCurrency;
    salesSummary.currentMonthGrossRevenue.decimals = 2;
  }
  const salesTransactions: Sale[] = get(dashboardState, ['salesTransactions']);
  const feeTiersList: FeeTier[] = get(dashboardState, ['tipsterFeeTiers']);
  const tipsterFeeTiers = new FeeTiers(
    feeTiersList,
    salesSummary.currentMonthGrossRevenue,
  );

  const navigateToPage = (cursor: any) => {
    getSales({
      period_filter: periodFilter.key,
      type_filter: typeFilter.key,
      cursor: cursor,
    });
  };

  return (
    <>
      {' '}
      {isFeeInfoModalOpen && tipsterFeeType === 'VARIABLE' && (
        <FeeInfoModal
          salesSummary={salesSummary}
          tipsterFeeTiers={tipsterFeeTiers}
          userCurrency={userCurrency}
          userName={userName}
          setIsFeeInfoModalOpen={setIsFeeInfoModalOpen}
          setIsFeeTierModalOpen={setIsFeeTierModalOpen}
        />
      )}
      {isFeeTierModalOpen && tipsterFeeType === 'VARIABLE' && (
        <div className={styles.feeTierModal}>
          <OutsideAlerter onBlur={() => setIsFeeTierModalOpen(false)}>
            <div className={styles.box}>
              <SVG
                src={closeIcon}
                className={styles.close}
                onClick={() => setIsFeeTierModalOpen(false)}
              />

              <div className={styles.headersContainer}>
                <h2 className={styles.header}>{tr(t, 'all_tiers')}</h2>

                <h3 className={styles.subHeader}>
                  {tr(t, 'tier_1_awaits_you')}
                </h3>
              </div>

              {!isEmpty(tipsterFeeTiers) &&
                tipsterFeeTiers.tiers.length > 0 &&
                !dashboardState.isLoading && (
                  <div className={styles.tiersList}>
                    {tipsterFeeTiers.tiers.map((feeTier: FeeTier) => (
                      <div
                        className={styles.feeTierBox}
                        key={feeTier.code}
                        style={{
                          border:
                            feeTier.code ===
                            tipsterFeeTiers.getCurrentTier(userCurrency).code
                              ? `solid 2px #242424`
                              : 'none',
                        }}
                      >
                        <div className={styles.left}>
                          <div
                            className={styles.currentTierIcon}
                            style={{
                              backgroundColor: `#${feeTier.backgroundIconColor}`,
                            }}
                          >
                            <img
                              className={styles.image}
                              src={feeTier.iconURL}
                            />
                          </div>
                        </div>

                        <div className={styles.right}>
                          <span
                            className={styles.currentTier}
                            style={{
                              backgroundColor: `#${feeTier.labelColor}`,
                              borderRadius: '8px',
                            }}
                          >
                            {feeTier.code.replace('_', ' ')}
                          </span>

                          <span className={styles.tierRange}>
                            {feeTier.formatFeeRange(userCurrency)}
                          </span>

                          <span className={styles.feePercentage}>
                            {100 - feeTier.tipsterFeePercentage}% {tr(t, 'of_fee')}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          </OutsideAlerter>
        </div>
      )}
      {!isEmpty(salesSummary) &&
        salesSummary.currentMonthGrossRevenue &&
        !isEmpty(feeTiersList) &&
        !isEmpty(tipsterFeeTiers) &&
        tipsterFeeTiers.tiers.length > 0 &&
        !dashboardState.isLoading && (
          <div className={styles.container} id={styles.earnings}>
            <div className={styles.section}>
              <div className={styles.sectionHeader}>
                <div>
                  <label>{tr(t, 'monetization')}</label>
                  <h1>{tr(t, 'sales')}</h1>
                </div>

                {tipsterFeeType === 'VARIABLE' && (
                  <div className={styles.feeTiersContainer}>
                    <div className={styles.left}>
                      <span
                        className={styles.currentTier}
                        style={{
                          backgroundColor:
                            tipsterFeeTiers.getCurrentColor(userCurrency),
                          borderRadius: '8px',
                        }}
                      >
                        {tipsterFeeTiers
                          .getCurrentTier(userCurrency)
                          .code.replace('_', ' ')}
                      </span>

                      <span
                        className={styles.grossIncomeInfo}
                        onClick={() => setIsFeeInfoModalOpen(true)}
                      >
                        {parse(
                          t('in_month_you_generated_gross_revenue', {
                            month: MONTH_NAMES[now.getMonth()],
                            gross_revenue:
                              salesSummary.currentMonthGrossRevenue.toString(),
                          }),
                        )}
                      </span>
                    </div>

                    <div
                      className={styles.right}
                      onClick={() => setIsFeeTierModalOpen(true)}
                    >
                      <div
                        className={styles.currentTierIcon}
                        style={{
                          backgroundColor:
                            tipsterFeeTiers.getCurrentColor(userCurrency),
                        }}
                      >
                        <img
                          className={styles.image}
                          src={
                            tipsterFeeTiers.getCurrentTier(userCurrency).iconURL
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.divisionLine}></div>
            <div className={styles.section}>
              <div className={styles.subHeader}>
                <div>
                  <h2>{tr(t, 'gross_income')}</h2>
                  <p>{salesSummary.totalSales.toString()}</p>
                </div>

                <div className={styles.filtersContainer}>
                  <span className={styles.complementaryText}>
                    ({tr(t, 'from_the_beginning')})
                  </span>

                  <div
                    className={
                      isOpenPeriodFilter
                        ? cx(styles.dropdown, styles.showLess)
                        : cx(styles.dropdown, styles.showMore)
                    }
                  >
                    <button
                      onClick={() => {
                        setIsOpenPeriodFilter(!isOpenPeriodFilter);
                        setIsOpenTypeFilter(false);
                      }}
                    >
                      {tr(t, periodFilter.label)}
                      <SVG src={dropdown} />
                    </button>

                    <div
                      className={
                        isOpenPeriodFilter
                          ? cx(styles.expanded, styles.dropdownItems)
                          : cx(styles.collapsed, styles.dropdownItems)
                      }
                    >
                      {periodFilterValues.map((filter) => {
                        return (
                          <label
                            key={filter.key}
                            onClick={() => {
                              setPeriodFilter(filter);
                              setPage(1);
                              !dashboardState.isLoading &&
                                getSales({
                                  period_filter: filter.key,
                                  type_filter: typeFilter.key,
                                });
                              setIsOpenPeriodFilter(false);
                            }}
                          >
                            {tr(t, filter.label)}
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  <div className={styles.typeFilterWrapper}>
                    <div
                      className={
                        isOpenTypeFilter
                          ? cx(styles.dropdown, styles.showLess)
                          : cx(styles.dropdown, styles.showMore)
                      }
                    >
                      <button
                        onClick={() => {
                          setIsOpenTypeFilter(!isOpenTypeFilter);
                          setIsOpenPeriodFilter(false);
                        }}
                      >
                        {tr(t, typeFilter.label)}
                        <SVG src={dropdown} />
                      </button>

                      <div
                        className={
                          isOpenTypeFilter
                            ? cx(styles.expanded, styles.dropdownItems)
                            : cx(styles.collapsed, styles.dropdownItems)
                        }
                      >
                        {typeFilters.map((filter) => {
                          return (
                            <label
                              key={filter.key}
                              onClick={() => {
                                handleTypeFilter(filter);
                              }}
                            >
                              {tr(t, filter.label)}
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.flex}>
                <div className={styles.chartWrapper}>
                  <SalesBarChart
                    summaryData={salesSummary}
                    periodFilter={periodFilter}
                  />

                  {isEmpty(salesSummary) && !dashboardState.isLoading && (
                    <label className={styles.emptyState}>
                      {' '}
                      {tr(t, 'no-data')}
                    </label>
                  )}
                  {dashboardState.isLoading && (
                    <label className={styles.emptyState}>
                      {' '}
                      {tr(t, 'loading')}...
                    </label>
                  )}
                </div>
                <div className={styles.earningsDataWrapper}>
                  <div className={styles.earningsCardWrapper}>
                    <label>
                      <img src={tipIcon} className={styles.coin} />
                      {tr(t, 'guaranteed_tips')}
                    </label>
                    <div className={styles.earningsCardBody}>
                      <div>
                        <div>
                          <p>{salesSummary.tipsCount}</p>
                          <h3>{tr(t, 'tips')}</h3>
                        </div>
                      </div>
                      <div>
                        <div>
                          <p>{salesSummary.tipsSales.toString()}</p>
                          <h3>{tr(t, 'earnings')}</h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={styles.earningsCardWrapper}>
                    <label>
                      <SVG src={premiumIcon}></SVG>
                      {tr(t, 'premium')}
                    </label>

                    <div className={styles.earningsCardBody}>
                      <div>
                        <div>
                          <p>{salesSummary.premiumsCount}</p>
                          <h3>{tr(t, 'sales')}</h3>
                        </div>
                      </div>

                      <div>
                        <div>
                          <p>{salesSummary.premiumsSales.toString()}</p>
                          <h3>{tr(t, 'earnings')}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={styles.earningsDataWrapperMobile}
                  style={{ width: '100%' }}
                >
                  <Carousel
                    responsive={responsiveConfig}
                    swipeable
                    draggable
                    infinite
                    autoPlay
                    autoPlaySpeed={5000}
                    containerClass={styles.carouselContainer}
                    dotListClass={styles.carouselDots}
                    showDots
                    arrows={false}
                  >
                    {(typeFilter.key === 'ALL' ||
                      typeFilter.key === 'TIPS') && (
                      <div className={styles.earningsCardWrapper}>
                        <label>
                          <img src={tipIcon} className={styles.coin}></img>
                          {tr(t, 'guaranteed_tips')}
                        </label>
                        <div className={styles.earningsCardBody}>
                          <div>
                            <div>
                              <p>{salesSummary.tipsCount}</p>
                              <h3>{tr(t, 'tips')}</h3>
                            </div>
                          </div>
                          <div>
                            <div>
                              <p>{salesSummary.tipsSales.toString()}</p>
                              <h3>{tr(t, 'earnings')}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {(typeFilter.key === 'ALL' ||
                      typeFilter.key === 'PREMIUMS') && (
                      <div className={styles.earningsCardWrapper}>
                        <label>
                          <SVG src={premiumIcon}></SVG>
                          {tr(t, 'premium')}
                        </label>
                        <div className={styles.earningsCardBody}>
                          <div>
                            <div>
                              <p>{salesSummary.premiumsCount}</p>
                              <h3>{tr(t, 'sales')}</h3>
                            </div>
                          </div>
                          <div>
                            <div>
                              <p>{salesSummary.premiumsSales.toString()}</p>
                              <h3>{tr(t, 'earnings')}</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Carousel>
                </div>
              </div>
            </div>

            <SalesTableConnected
              transactionsData={salesTransactions}
              downloadAllCsv={dashboardState.allCsvSummary}
              isLoading={dashboardState.isLoading}
              isRequested={dashboardState.requested}
              navigateToPage={navigateToPage}
              periodFilter={periodFilter}
              typeFilter={typeFilter}
              page={page}
              setPage={setPage}
              userId={userId}
            />
          </div>
        )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  dashboardState: state.dashboard,
  loginState: state.login,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSales: (queryparams: any) =>
    dispatch(dashboardActions.salesRequestAction(queryparams)),
});

export const SalesConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sales);
